import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import 'sal.js/dist/sal.css';
import sal from 'sal.js';

import MediaCard from 'components/shared/media-card';

const MediaGrid = ({ blok }) => {
  useEffect(() => {
    if (blok.animate) {
      sal({ threshold: 0.25 });
    }
  }, [blok.animate]);

  const isAnimate = blok.animate;

  let gridTemplate;

  if (blok.grid_layout_style === 'projects') {
    gridTemplate = (
      <>
        {blok.blocks.map((blok, index) => {
          const index1 = index + 1;
          let gridClass = '';
          let aspectRatioClass = 'aspect-[520/320]';
          let containerClass = '';
          if (index1 === 1) {
            gridClass = 'col-span-full';
          } else if (index1 % 6 === 2) {
            gridClass = 'mobile:row-span-2 justify-end lg:col-span-2';
            aspectRatioClass = 'mobile:aspect-[520/820] lg:aspect-[520/320]';
          } else if (index1 % 6 === 3) {
            gridClass = 'mobile:row-span-2 justify-end';
            aspectRatioClass = 'aspect-[520/320]';
            containerClass = 'lg:justify-end';
          } else if (index1 % 6 === 4) {
            gridClass = 'mobile:col-span-full lg:justify-start lg:row-span-2';
          } else if (index1 % 6 === 5) {
            gridClass = 'mobile:row-span-2 lg:row-span-2';
            aspectRatioClass = 'mobile:aspect-[520/320] lg:aspect-[520/820]';
          } else if (index1 % 6 === 0) {
            gridClass = 'mobile:row-span-2 lg:justify-start lg:row-span-2';
            aspectRatioClass = 'mobile:aspect-[520/820]';
          }
          return (
            <div
              className={`flex h-full flex-col ${gridClass}`}
              key={blok._uid}
              {...(isAnimate
                ? {
                    'data-sal': 'slide-up',
                    'data-sal-duration': '1000',
                    'data-sal-delay': '0',
                    'data-sal-easing': 'ease',
                  }
                : {})}
            >
              <MediaCard
                blok={blok}
                aspectRatioClass={aspectRatioClass}
                containerClass={containerClass}
              />
            </div>
          );
        })}
      </>
    );
  }

  if (blok.grid_layout_style === 'pages') {
    gridTemplate = (
      <>
        {blok.blocks.map((blok, index) => {
          const index1 = index + 1;
          let gridClass = '';
          let aspectRatioClass = 'aspect-[520/320] ';
          const captionClass = 'lg:!pt-4 lg:!pb-0 xl:!pt-5';
          if (index1 === 1) {
            gridClass = 'row-span-2';
            aspectRatioClass = 'aspect-[520/820] flex-1';
          } else if (index1 % 4 === 2) {
            gridClass = 'mobile:row-span-2';
            aspectRatioClass = 'aspect-[520/320] lg:flex-1';
          } else if (index1 % 4 === 3) {
            aspectRatioClass = 'flex-1';
          } else if (index1 % 4 === 0) {
            gridClass = 'lg:col-[3]';
            aspectRatioClass = 'flex-1';
          }
          return (
            <div
              className={`flex h-full flex-col ${gridClass}`}
              key={blok._uid}
              {...(isAnimate
                ? {
                    'data-sal': 'slide-up',
                    'data-sal-duration': '1000',
                    'data-sal-delay': '0',
                    'data-sal-easing': 'ease',
                  }
                : {})}
            >
              <MediaCard
                blok={blok}
                aspectRatioClass={aspectRatioClass}
                titleClass="!font-medium"
                captionClass={captionClass}
              />
            </div>
          );
        })}
      </>
    );
  }

  if (blok.grid_layout_style === 'news') {
    gridTemplate = (
      <>
        {blok.blocks.map((blok, index) => {
          const index1 = index + 1;
          let gridClass = '';
          let aspectRatioClass = 'aspect-[520/320] ';
          let containerClass = '';
          const captionClass = 'lg:line-clamp-2 lg:flex-[0_0_95px] xl:flex-[0_0_145px]';
          if (index1 === 2) {
            gridClass = 'row-span-2 lg:justify-end';
            aspectRatioClass = 'aspect-[520/820]';
            containerClass = 'lg:h-full';
          } else if (index1 % 4 === 1) {
            gridClass = 'mobile:row-span-2';
            aspectRatioClass = 'mobile:aspect-[520/320] lg:aspect-[520/320]';
          } else if (index1 % 4 === 3) {
            gridClass = 'lg:row-[span_2] lg:self-end';
            aspectRatioClass = 'lg:aspect-[520/320]';
          } else if (index1 % 4 === 0) {
            gridClass = 'lg:self-end';
            aspectRatioClass = 'lg:aspect-[520/320]';
          }
          return (
            <div
              className={`${gridClass}`}
              key={blok._uid}
              {...(isAnimate
                ? {
                    'data-sal': 'slide-up',
                    'data-sal-duration': '1000',
                    'data-sal-delay': '0',
                    'data-sal-easing': 'ease',
                  }
                : {})}
            >
              <MediaCard
                blok={blok}
                aspectRatioClass={`${aspectRatioClass} lg:flex-1`}
                containerClass={containerClass}
                captionClass={captionClass}
              />
            </div>
          );
        })}
      </>
    );
  }

  if (blok.grid_layout_style === 'about') {
    gridTemplate = (
      <>
        {blok.blocks.map((blok, index) => {
          const index1 = index + 1;
          let gridClass = '';
          let aspectRatioClass = 'aspect-[520/320] ';
          let containerClass = '';
          if (index1 % 5 === 2) {
            gridClass = 'mobile:order-3 mobile:col-span-full lg:row-span-2';
            aspectRatioClass = 'aspect-[400/225]lg:aspect-[520/820] lg:flex-1';
            containerClass = 'lg:flex-1';
          } else if (index1 % 5 === 1) {
            gridClass = 'mobile:order-first';
          } else if (index1 % 5 === 3) {
            gridClass = 'mobile:order-2';
          } else if (index1 % 5 === 4) {
            gridClass = 'mobile:order-4';
          } else if (index1 % 5 === 0) {
            gridClass = 'mobile:order-last';
          }
          return (
            <div
              className={`flex h-full flex-col ${gridClass}`}
              key={blok._uid}
              {...(isAnimate
                ? {
                    'data-sal': 'slide-up',
                    'data-sal-duration': '1000',
                    'data-sal-delay': '0',
                    'data-sal-easing': 'ease',
                  }
                : {})}
            >
              <MediaCard
                blok={blok}
                aspectRatioClass={aspectRatioClass}
                containerClass={containerClass}
              />
            </div>
          );
        })}
      </>
    );
  }

  if (!blok.grid_layout_style) {
    gridTemplate = (
      <>
        {blok.blocks.map((blok) => (
          <div
            className="flex h-full flex-col"
            key={blok._uid}
            {...(isAnimate
              ? {
                  'data-sal': 'slide-up',
                  'data-sal-duration': '1000',
                  'data-sal-delay': '0',
                  'data-sal-easing': 'ease',
                }
              : {})}
          >
            <MediaCard blok={blok} />
          </div>
        ))}
      </>
    );
  }

  return (
    <div className="container grid grid-cols-2 gap-5 overflow-hidden py-7 lg:grid-cols-3 lg:py-8 xl:py-10">
      {/* <div data-sal="slide-up" data-sal-duration="1000" data-sal-delay="0" data-sal-easing="ease" style={{ height: '600px', width: '600px', backgroundColor: 'red'}}>data sal animation</div> */}
      {gridTemplate}
    </div>
  );
};

export default MediaGrid;

MediaGrid.propTypes = {
  blok: PropTypes.object.isRequired,
};
